import { inject, makeStateKey, TransferState } from "@angular/core";
import { ResolveFn } from "@angular/router";
import { TServiceResult } from "@shared/helper/t-service-result";
import { PageList } from "@shared/model/categoryAndSearch/pageList-model";
import { IClubMeetingModel } from "@app/pages/clubs/models/club-meeting-model";
import { of, switchMap } from "rxjs";
import { LocalRepository } from "@shared/helper/local-repository";
import { ClubMeetingService } from "@app/pages/clubs/services/club-meeting.service";
import { TermFilterModel } from "@shared/model/categoryAndSearch/term-filter-model";

export const STATE_KEY_MEETING_LIST = makeStateKey<MeetingListResolverData>("STATE_KEY_MEETING_LIST");

export const MeetingListResolver: ResolveFn<MeetingListResolverData> = (route, state) => {
  const termFilters = new TermFilterModel();

  const _localRepository: LocalRepository = inject(LocalRepository);
  const serverState: TransferState = inject(TransferState);
  const meetingService: ClubMeetingService = inject(ClubMeetingService);
  if (!_localRepository.IsInBrowser) {
    return meetingService.getClubMeetings(route.paramMap.get('id')!, termFilters)
      .pipe(switchMap(res => {
        serverState.set(STATE_KEY_MEETING_LIST, res);
        return of(res);
      }))
  }

  return of(serverState.get(STATE_KEY_MEETING_LIST, TServiceResult.fromFailure<any>(null)))

}

export type MeetingListResolverData = TServiceResult<PageList<IClubMeetingModel>>;
